// Keep refreshes and saves in order, even when a row is collapsed while saving.
export function createOrderingSync() {
  let revision = 0
  let pending = 0
  let tail = Promise.resolve()
  const edits = new Map()

  return {
    capture: () => revision,
    async whenIdle() { while (pending > 0) await tail },
    canRefresh: (startedAt) => pending === 0 && startedAt === revision,
    invalidate: () => { revision += 1 },
    save({ key, value, previous, write, apply, onError }) {
      const edit = edits.get(key) || { confirmed: previous, version: 0 }
      edits.set(key, edit)
      const version = ++edit.version
      pending += 1
      revision += 1
      apply(value, true)
      const operation = tail.then(async () => {
        try {
          await write(value)
          edit.confirmed = value
          if (version === edit.version) apply(value, false)
        } catch (error) {
          if (version === edit.version) {
            apply(edit.confirmed, false)
            onError(error)
          }
        } finally {
          pending -= 1
          revision += 1
          if (version === edit.version) edits.delete(key)
        }
      })
      // A failed save must not stop subsequent edits from reaching the server.
      tail = operation.catch(() => {})
      return operation
    },
  }
}
